import React from "react";
import Axios from 'axios'
import MasterTemplate from "./MasterTemplate";
import API from '../Utils/api'


export class GerenciarSeries extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            series: [],
            filteredList: []
        };

        this.getSeries()
    }


    async getSeries() {
        try {
          var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
          });
          const response = await axiosInstance.get("series/tipo-subserie");
            this.setState({series: response.data, filteredList: response.data});
        } catch (err) {
            console.log(err);
        }
      };

      async unlockSerie(e) {
        try {
          var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
          });
          const response = await axiosInstance.put("series/unlock", {_id : e.target.accessKey});

          if(response.data){
              alert("Série desbloqueada!");
              window.location.reload();
          }
        } catch (err) {
            console.log(err);
        }
      };

    handlerList(e){
        var filteredList = [];
        this.state.series.map(item => {
            if(item.cambistaId.nome.toLowerCase().includes(e.target.value.toLowerCase())){
                filteredList.push(item)
            }
        })
        this.setState({filteredList: filteredList});
        if(e.target.value == "" || e.target.value == null){
            this.setState({filteredList: this.state.series});
      }

    }

    render() {
        return (
            <MasterTemplate label={'Gerenciar Séries'}>

                                    <div className="row pl-5 pr-5 justify-content-center">
                                         <input className="ml-5 w-50 form-control" placeholder="Filtrar por nome do cambista" onChange={this.handlerList.bind(this)}></input>
                                    </div>
                                    <table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                            <th>Cambista</th>
                                            <th>Gerente</th>
                                            <th>Nº da série</th>
                                            <th>X vezes Impressa</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.filteredList.map((item, index) => {
                                            return (
                                                <tr >
                                                    <td>{item?.cambistaId.nome}</td>
                                                    <td>{item?.gerenteId.nome.substring(0,17)}...</td>
                                                    <td className="text-center">{item?.numero}</td>
                                                    <td className="text-center" >{item?.printNumber? item?.printNumber : 0}</td>
                                                    <td>
                                                    <button className={item?.isBusy? "btn-fill btn btn-danger cursor-point" : "d-none" } accessKey={item._id} onClick={this.unlockSerie.bind(this)}>{item?.isBusy ? "Desbloquear"  : "..."}</button>
                                                    <span className={item?.isBusy? "d-none" : "text-success" }>Aberta</span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
            </MasterTemplate>
        );
    }
}

export default GerenciarSeries;
